import { render, staticRenderFns } from "./BarGraph.vue?vue&type=template&id=b2582778"
import script from "./BarGraph.vue?vue&type=script&lang=js"
export * from "./BarGraph.vue?vue&type=script&lang=js"
import style0 from "./BarGraph.vue?vue&type=style&index=0&id=b2582778&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports